import React from 'react';
import linkedIn from '../../../assets/linkedIn.svg';

const HoverImage = ({ src, line1, line2, linkedInUrl }) => {
  return (
    <div className="relative w-auto h-auto overflow-hidden group lg:m-2">
      <div className="lg:w-full lg:h-full overflow-hidden">
        <img
          src={src}
          alt=""
          className="lg:w-full lg:h-full object-cover transform scale-100 filter grayscale transition-transform duration-700 ease-in-out group-hover:scale-110 group-hover:grayscale-0"
        />
      </div>
      {/* Text and LinkedIn Icon Overlay */}
      <div className="absolute bottom-3 left-5 right-5 flex items-center justify-between">
        <div className="font-inter leading-tight">
          <span className="font-bold text-sm md:text-base text-white">{line1}</span>
          <br />
          <span className="font-medium text-[10px] md:text-sm text-[#FFFFFFCC]">{line2}</span>
        </div>
        <a
          href={linkedInUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="z-10"
        >
          <img src={linkedIn} alt="LinkedIn" />
        </a>
      </div>
    </div>
  );
};

export default HoverImage;
